import React from "react";
import SbEditable from "storyblok-react";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css"
import StoryblokClient from 'storyblok-js-client'

const Storyblok = new StoryblokClient({
    accessToken: 'LZGFxjR34cofPNlwzU6wgwtt',
    cache: {
      clear: 'auto',
      type: 'memory'
    }
})


export default class article extends React.Component {
  render() {
    const { blok } = this.props;
    const { full } = this.props;
    const { published_at } = this.props;
    const { slug } = this.props;
    const makeImageArr = ({ slide }) => {
      let imgArray = [];
      slide.forEach((item) => {
        let temp = {};
        temp.original = item.image.filename;
        imgArray.push(temp);
      });
      return imgArray;
    }
    return (      
      <SbEditable content={blok}>
        <div className="my-6">
          <div className="w-full">            
            {blok.image.filename != null && blok.image.filename != "" ? (
              <div className="blog__article__image">
                <img src = {blok.image.filename}/>
              </div>
            ):""}
            
            {blok.video.filename != null && blok.video.filename != "" ? (
              <div className="blog__article__image">
                <video controls>
                  <source src={blok.video.filename} type="video/mp4"></source>
                </video>
              </div>
            ):""}              
            {blok.slide.length !== 0 ? (
              <div className="blog__article__image">
                <ImageGallery 
                  items={makeImageArr(blok)}
                  showThumbnails={false}
                  showPlayButton={false}
                  showFullscreenButton={false}
                  autoPlay={true}
                />
              </div>
            ):""}              
          </div>
          <div className="blog__article__title">
            {
              full === true ? 
              (
                <h3 dangerouslySetInnerHTML={{__html:  blok.title.type ? Storyblok.richTextResolver.render(blok.title):blok.title}} />
              ) 
              :
              (
                <a href={ slug}>
                  <h3 dangerouslySetInnerHTML={{__html:  blok.title.type ? Storyblok.richTextResolver.render(blok.title):blok.title}} /> 
                </a>
              )
            }
            
          </div>
          {/* <div className="blog__article__icons">
            <div className="row text-gray-500">
            {blok.nav.map((blok) => {
                const genClass = (blok) => {
                  const { icon } = blok;
                  return `${icon.type} ${icon.icon}`
                }
                return  (
                  <a href="#" key={blok._uid}><i className={genClass(blok)}></i>{' ' + blok.name}</a>
                )}
              )}
            </div>
          </div> */}
          {
            // console.log("new rich text",  Storyblok.richTextResolver.render( blok.full_text),)
          }
          {full === true ? (
            <div className="blog__article__text">
            <div dangerouslySetInnerHTML={{__html:  blok.full_text.type ? Storyblok.richTextResolver.render(blok.full_text):blok.full_text}} />
          </div>
          ): (
            <div className="blog__article__text">
            <p dangerouslySetInnerHTML={{__html:  blok.intro_text }} />
          </div>
          

          )}
          <p className="blog__published">Published at 
            {
              " " + new Date(published_at).toLocaleString()
            }
          </p>
        </div>
      </SbEditable>
    );
  }
}
